import { Model } from "./Base.js";

export class AvisosModel extends Model {
    get defaults() {
        return {
            mensagem: "",
            usuario: "",
        };
    }
}